import { Link } from 'react-router-dom';

interface HeroSectionProps {
  scrollTo: (id: string) => void;
}

export default function HeroSection({ scrollTo }: HeroSectionProps) {
  return (
    <section className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20architectural%20library%20interior%20with%20soaring%20white%20walls%20and%20floor-to-ceiling%20bookshelves%20organized%20by%20topic%2C%20soft%20diffused%20daylight%20from%20large%20clerestory%20windows%20casting%20gentle%20shadows%2C%20clean%20minimalist%20corporate%20aesthetic%20with%20subtle%20teal%20accent%20panels%2C%20warm%20ivory%20tones%20throughout%2C%20abstract%20geometric%20ceiling%20design%2C%20quiet%20scholarly%20atmosphere%2C%20professional%20high-end%20interior%20photography%2C%20no%20people%20no%20text%20no%20branding&width=1920&height=800&seq=encyclopedia-hero-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/70"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-6 pt-24 md:pt-20">
          <div className="text-center">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-5 py-2 mb-6">
              <i className="ri-book-read-line text-teal-300"></i>
              <span className="text-white/90 text-sm font-medium">Центр знаний Business Training</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight max-w-4xl mx-auto">
              Энциклопедия корпоративного обучения сотрудников
            </h1>
            <p className="text-base md:text-xl text-white/85 mb-10 max-w-3xl mx-auto leading-relaxed">
              Самое полное практическое руководство по корпоративному обучению сотрудников, развитию персонала и построению эффективной системы обучения в компании.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => scrollTo('what-included')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-article-line mr-2"></i>
                Изучить материалы
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="bg-white/15 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/25 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-chat-smile-3-line mr-2"></i>
                Получить консультацию
              </button>
            </div>

            {/* Stats strip */}
            <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
              {[
                { value: '4500+', label: 'участников обучено' },
                { value: '100+', label: 'корпоративных проектов' },
                { value: '18+', label: 'лет опыта' },
                { value: '450+', label: 'тренингов проведено' },
              ].map((stat) => (
                <div key={stat.label} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="text-2xl md:text-3xl font-extrabold text-teal-300">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}